import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetRequestBroadChannelDropdownQuery } from '../../../../api/endpoints/teamProductivityMeasurement';
import { useLanguage } from '../../../../contexts/LanguageContext';

const RequestBroadChannelDropdown = ({ value, onChange, disabled, className }) => {
    const { getCurrentLanguageId, th } = useLanguage();
    const languageId = getCurrentLanguageId();

    const { data: list = [], isLoading } = useGetRequestBroadChannelDropdownQuery({ LanguageId: languageId });

    const options = useMemo(() =>
        list.map((item) => ({
            label: item.text || item.Text,
            value: item.iD || item.id || item.ID
        })),
        [list]
    );

    return (
        <Dropdown
            value={value}
            options={options}
            onChange={(e) => onChange(e.value)}
            disabled={disabled}
            loading={isLoading}
            placeholder={th('teamProductivity.placeholders.requestSender')}
            showClear
            filter
            className={className}
        />
    );
};

export default RequestBroadChannelDropdown;